module.exports = __webpack_public_path__ + "images/private-investor-7a1a0b.png";